<div [ngClass]="showAddAppointment? 'showContent' :'hideContent' ">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>
            <!-- lblAddAppointment -->
            lblSearchVehicle/Customer
        </h4>
        <button type="button" class="close" aria-label="Close" (click)="OnClose()" aria-label="Center Align">
            <span aria-hidden="true">
                ×
            </span>
        </button>
    </div>

    <div class="width100" *ngIf="!addDetails  && !selectDate">
        <div class="modal-body p-0 maxh85vh">


            <!--Lincense Plate-->
            <div class="card pad7x">

                <div class="row">


                    <div class="col-auto">

                        <label translate>lblAppointmentType</label>
                        <div class="form-row">

                            <div class="col-auto mr-4">

                                <div class="  p-0">
                                    <input type="radio" id="offer" [(ngModel)]="isOrder" [value]="false"
                                        class="radio-custom" />
                                    <label class="form-check-label" for="offer" translate>lblOffer</label>
                                </div>
                            </div>
                            <div class="col-auto">
                                <div class="  p-0">
                                    <input type="radio" id="order" [(ngModel)]="isOrder" [value]="true"
                                        class="radio-custom" />
                                    <label class="form-check-label" for="order" translate>lblOrder</label>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div class='col col-3'>

                        <div class="controls">
                            <label translate>lblSearchVehicle</label>
                        </div>
                        <div class="form-row">
                            <div class='col'>
                                <div class="lbl-info">
                                    <div class="input-group">
                                        <input type="text" id="licensePlate" name="licensePlate"
                                            [(ngModel)]="licensePlatNo" maxlength="20" class="form-control"
                                            [ngClass]=is-invalid (keyup.enter)="SearchLicensePLate()" appAutofocus tabindex="1">
                                        <div class="input-group-append" >
                                            <button type="button" (click)="onSearchLicensePLate()"
                                                class="btn btn-primary" aria-label="Center Align" #inp>
                                                <i class="fa fa-search" aria-hidden="true"></i>
                                            </button>
                                            <button type="button" class="btn btn-primary ml-1"
                                                (click)="onRegAdvanceSearch()" aria-label="Center Align">
                                                <em class="fa fa-search-plus" aria-hidden="true"></em>
                                            </button>
                                            <div class="searchbox card fix lt" [ngClass]="!hideExtraInformation ? 'width700px' : 'width500px'" *ngIf="RegAdvanceSearch">
                                                <div class="row mt-2">
                                                    <div [ngClass]="!hideExtraInformation ? 'col-4' : 'col-6'">
                                                        <label translate class="text-left">lblRegNumber</label>
                                                        <input class="form-control border" type="text"
                                                            name="licensePlate"
                                                            [(ngModel)]="RegAdvanceSearchRequestModel.licensePlate"
                                                            maxlength="10" autocomplete="off" />
                                                    </div>
                                                    <div [ngClass]="!hideExtraInformation ? 'col-4' : 'col-6'">
                                                        <label translate class="text-left">lblVinNumber</label>
                                                        <input class="form-control border" type="text" name="VINNumber"
                                                            [(ngModel)]="RegAdvanceSearchRequestModel.VINNumber"
                                                            maxlength="25" autocomplete="off" />
                                                    </div>
                                                    <div class="col-4" *ngIf="!hideExtraInformation">
                                                        <label translate class="text-left">lblEngineNumber</label>
                                                        <input class="form-control border" type="text"
                                                            name="engineNumber"
                                                            [(ngModel)]="RegAdvanceSearchRequestModel.engineNumber"
                                                            maxlength="80" autocomplete="off" />
                                                    </div>
                                                </div>
                                                <div class="mb-4"></div>
                                                <hr />
                                                <div class="row">
                                                    <div class="col-auto me-auto text-right">
                                                        <button type="button" (click)="ApplyRegAdvanceSearch()"
                                                            aria-label="Center Align" class="btn btn-primary mr-sm-2"
                                                            translate>lblApply
                                                        </button>
                                                        <button (click)="ResetRegAdvanceSearch()"
                                                            aria-label="Center Align"
                                                            class="btn btn-outline-primary mr-sm-2" translate>lblReset
                                                        </button>
                                                        <button (click)="CloseRegAdvanceSearch()"
                                                            aria-label="Center Align" class="btn btn-outline-primary"
                                                            translate>lblClose
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div *ngIf="searchLicensePlate &&  licensePlatNo?.length === 0" style="color: red;"
                                    class="cst-validation-msg">
                                    <i class="fa fa-exclamation-circle" aria-hidden="true"></i><span
                                        translate>lblPleaseEnterTheValidValue</span>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class='col col-3'>
                        <div class="controls">
                            <label translate>lblSearchbyexistingmobileno</label>
                        </div>
                        <div class="input-group">
                            <input type="text" [(ngModel)]="mobileNumber" class="form-control"
                                (keypress)="isDigit($event)" minlength="6" maxlength="15"
                                (keyup.enter)="getCustomerDetailsUsingMobileQuickSearch()" tabindex="2"/>
                            <div class="input-group-append">
                                <button type="button" (click)="getCustomerDetailsUsingMobileQuickSearch()" class="btn btn-primary"
                                    aria-label="Center Align">
                                    <i class="fa fa-search" aria-hidden="true"></i>
                                </button><br>
                                <button type="button" class="btn btn-primary ml-1 btn-r"
                                    (click)="onMobileAdvanceSearch()" aria-label="Center Align">
                                    <em class="fa fa-search-plus" aria-hidden="true"></em>
                                </button>
                                <div class="searchbox card fix lt" [ngClass]="!hideExtraInformation ? 'width700px' : 'width500px'" *ngIf="MobileAdvanceSearch">
                                    <div class="row mt-2">
                                        <div [ngClass]="!hideExtraInformation ? 'col-4' : 'col-6'">
                                            <label translate>lblMobileNumber</label>
                                            <input class="form-control" type="text" name="mobileNo"
                                                [(ngModel)]="MobileAdvanceSearchRequestModel.mobileNo" maxlength="10"
                                                autocomplete="off" />
                                        </div>
                                        <div  class="col-4" *ngIf="!hideExtraInformation">
                                            <label translate>lblCustomerNumber</label>
                                            <input class="form-control" type="text" name="customerNo"
                                                [(ngModel)]="MobileAdvanceSearchRequestModel.customerNo" maxlength="25"
                                                autocomplete="off" />
                                        </div>
                                        <div [ngClass]="!hideExtraInformation ? 'col-4' : 'col-6'">
                                            <label translate>lblFirstName</label>
                                            <input class="form-control" type="text" name="firstName"
                                                [(ngModel)]="MobileAdvanceSearchRequestModel.firstName" maxlength="80"
                                                autocomplete="off" />
                                        </div>
                                    </div>

                                    <div class="mb-4"></div>
                                    <hr />
                                    <div class="row">
                                        <div class="col-auto me-auto text-right">
                                            <button type="submit" (click)="ApplyMobileAdvanceSearch()"
                                                aria-label="Center Align" class="btn btn-primary mr-sm-2"
                                                translate>lblApply
                                            </button>
                                            <button (click)="ResetMobileAdvanceSearch()" aria-label="Center Align"
                                                class="btn btn-outline-tertiary mr-sm-2" translate>lblReset
                                            </button>
                                            <button (click)="CloseMobileAdvanceSearch()" aria-label="Center Align"
                                                class="btn btn-outline-tertiary" translate>lblClose
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div *ngIf="mobileNumber?.length > 0 && (mobileNumber?.length < 6 || mobileNumber?.length > 15) && !mobileNumber?.match('^[0-9]$')"
                            style="color: red;" class="cst-validation-msg">
                            <i class="fa fa-exclamation-circle" aria-hidden="true"></i><span
                                translate>lblPleaseEnterTheValidValue</span>
                        </div>
                    </div>
                    <div class="col-md-3">

                        <label translate>lblDealersName</label><span class="text-danger"> *</span>

                        <select class="form-control" (change)="onChangeDealer($event.target.value)" name="dealer"
                            [(ngModel)]="loginDealerIndex" tabindex="3">
                            <option selected [value]="-1" disabled translate>lblSelectDealer
                            </option>
                            <option *ngFor="let dealer of dealerDeatilList; let i = index" [value]="dealer.dealerId">
                                {{dealer.dealerName}}
                            </option>
                        </select>
                    </div>
                </div>

            </div>
            <div class="pad15">
                <div class="card pad15">
                    <div class="ctm-tab card-accord  custom-card card-body-p0">
                        <ngb-accordion #a="ngbAccordion" class="overflow-none-card" [activeIds]="openPanels">
                            <ngb-panel id="first" *ngIf="serachByLicensePlate">
                                <ng-template ngbPanelHeader class="custom-header ctm">
                                    <div class="d-flex align-items-center">
                                        <button ngbPanelToggle translate
                                            class="btn d-flex w-100 align-items-center text-left"
                                            aria-label="Center Align">
                                            lblVehicle
                                            <ng-container *ngIf="!a.activeIds.includes('first')"><em
                                                    class="fas fa-angle-down fa-lg ml-auto"></em>
                                            </ng-container>
                                            <ng-container *ngIf="a.activeIds.includes('first')"><em
                                                    class="fas fa-angle-up fa-lg ml-auto"></em>
                                            </ng-container>
                                        </button>
                                    </div>
                                </ng-template>
                                <ng-template ngbPanelContent>
                                    <div class="maxh-auto">
                                        <table class="tablest1 border-bottom mt-2">
                                            <ng-container>
                                                <thead>
                                                    <tr>
                                                        <th scope="col" translate>lblSource</th>
                                                        <th scope="col" translate>lblRegNumber</th>
                                                        <th scope="col" translate>lblVinNumber</th>
                                                        <th scope="col" translate>lblRegistrationDate</th>
                                                        <th scope="col" translate>lblNextInspectionDate</th>
                                                        <th scope="col" translate>lblYear</th>
                                                        <th scope="col" translate>lblImportedCar</th>
                                                        <th style="width:11%" scope="col" class="text-center" translate>
                                                            lblAction
                                                        </th>
                                                    </tr>
                                                </thead>
                                            </ng-container>

                                            <tbody>
                                                <ng-container
                                                    *ngIf="vehicleList?.length>0 || vehicleDetails?.length>0; else load_else">
                                                    <ng-container *ngIf="vehicleList?.length>0">
                                                        <tr *ngFor="let vehicle of vehicleDetails; let i=index">
                                                            <td>{{vehicle.searchSource}} </td>
                                                            <td>
                                                                <div class="flmid">
                                                                    <div class="licplate LPNo d-flex">
                                                                        <span class="icn-flag"
                                                                            [ngClass]="licensePlateClass"></span>
                                                                        {{vehicle.licensePlate}}
                                                                    </div>
                                                                    <div class="imgWid">
                                                                        <ng-container>
                                                                            <img af-brand-logo [data-code]="vehicle.makeCode"
                                                                                data-type="BRAND"
                                                                                class="{{vehicle.makeCode}}-icon brandicon"
                                                                                alt="not found" />
                                                                        </ng-container>
                                                                    </div>
                                                                </div>
                                                                <div class="mt-1">
                                                                    <ngb-highlight [result]="vehicle.model"
                                                                        class="flmid semibold fs-12px lh-16px"></ngb-highlight>
                                                                </div>
                                                            </td>
                                                            <td>{{vehicle.chassisNo}} </td>
                                                            <td *ngIf="vehicle.searchSource !== 'Data Factory'">{{vehicle.registrationDate | date:'shortDate'}} </td>
                                                            <td *ngIf="vehicle.searchSource !== 'Data Factory'">{{vehicle.inspectionNextDate | date:'shortDate'}} </td>
                                                            <td *ngIf="vehicle.searchSource === 'Data Factory'">{{vehicle.registrationDate}} </td>
                                                            <td *ngIf="vehicle.searchSource === 'Data Factory'">{{vehicle.inspectionNextDate}} </td>
                                                            <td>
                                                               {{vehicle.year}}
                                                            </td>
                                                            <td  class="text-center"> 
                                                                <ng-container
                                                                    *ngIf="vehicle.isImported; else load_else_isImported">
                                                                    <em class="fas fa-check"></em>
                                                                </ng-container>
                                                                <ng-template #load_else_isImported>
                                                                    <em
                                                                        class="fas fa-times text-danger cursordisable"></em>
                                                                </ng-template>
                                                            </td>
                                                            <td class="text-center">
                                                                <a class="btn btn-ico" ngbTooltip="Associate Customer"
                                                                    [hidden]="!AssociateCustomer || vehicle.searchSource !== 'Local'"
                                                                    (click)="AssociateCustomerWithVehicle(vehicle)">
                                                                    <em class="fa fa-users fa-lg"></em>
                                                                </a>
                                                                <a class="btn btn-ico" *ngIf="vehicle.remark && (vehicle.searchSource === 'Local' || vehicle.searchSource === 'CRM')" [ngbTooltip]="tipContent" placement="auto" container="body"> <em class="fa fa-info fa-lg"></em> </a>
                                                                <ng-template #tipContent> 
                                                                    <div class="text-left p-2" style="max-width: 400px;"> 
                                                                        <span> <b> <span translate> lblRemark</span>: </b> </span> <br>
                                                                        <span> {{ vehicle.remark }} </span> 
                                                                    </div> 
                                                                </ng-template>
                                                                <span class="ico-div" [class.invisible]="!AssociateCustomer  || vehicle.searchSource !== 'Local'"></span>
                                                                <a class="btn btn-ico" ngbTooltip="Edit" *ngIf="userRoleRightsDetailsVehicle.canEdit" (click)="viewVehicle(vehicle,false)"
                                                                    [hidden]="!(vehicle.searchSource === 'Local' || (_clientName === 'mg' && vehicle.isExistingVehicle))">
                                                                    <em class="fas fa-pencil-alt fa-lg"></em>
                                                                </a>

                                                            </td>
                                                        </tr>
                                                    </ng-container>

                                                </ng-container>
                                                <ng-template #load_else>
                                                    <tr>
                                                        <td colspan="5" class="no-record" translate>lblNoRecordsFound
                                                        </td>
                                                    </tr>
                                                </ng-template>
                                            </tbody>
                                        </table>
                                    </div>
                                </ng-template>
                            </ngb-panel>
                            <ngb-panel id="second" *ngIf="serachByLicensePlate">
                                <ng-template ngbPanelHeader class="custom-header ctm">
                                    <div class="d-flex align-items-center">
                                        <button ngbPanelToggle translate
                                            class="btn d-flex w-100 align-items-center text-left"
                                            aria-label="Center Align">
                                            lblCustomers
                                            <ng-container *ngIf="!a.activeIds.includes('second')"><em
                                                    class="fas fa-angle-down fa-lg ml-auto"></em>
                                            </ng-container>
                                            <ng-container *ngIf="a.activeIds.includes('second')"><em
                                                    class="fas fa-angle-up fa-lg ml-auto"></em>
                                            </ng-container>
                                        </button>
                                    </div>
                                </ng-template>
                                <ng-template ngbPanelContent>
                                    <div class="maxh-auto">
                                        <table class="tablest1 border-bottom mt-2">
                                            <thead>
                                                <tr>
                                                    <th scope="col" class="text-center" translate>#</th>
                                                    <th scope="col" translate>lblSource</th>
                                                    <th scope="col" translate>lblCustomerNumber</th>
                                                    <th scope="col" translate>lblCustomerName</th>
                                                    <th scope="col" translate>lblAddress</th>
                                                    <th scope="col" translate>lblOwnerType</th>
                                                    <th scope="col" class="text-center" translate>lblIsCompany</th>
                                                    <th scope="col" class="text-center" translate>lblIsActive</th>
                                                    <th scope="col" class="text-center" translate>lblAction</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <ng-container *ngIf="customerDetails?.length>0; else load_else">
                                                    <ng-container *ngIf="customerDetails?.length>0; else Details">
                                                        <tr *ngFor="let customer of customerDetails; let i=index"
                                                            [ngClass]="{'clrRed' : !customer.isActive}">
                                                            <td> 
                                                                <input type="radio" name="list" class="radio-custom"
                                                                    value="{{customer.customerId}}" *ngIf="customer.searchSource !== 'Data Factory'"
                                                                    [checked]="(!hideExtraInformation && customer.customerId==SelectedCustomerId) || (_clientName === 'mg' && customer.Id === SelectedCustomerGuid)"
                                                                    (change)="onCustomerChange(customer)" />
                                                            </td>
                                                            <td>{{customer.searchSource}} </td>
                                                            <td>{{customer.customerNo}}
                                                            <td>{{customer.customerName}}
                                                                <br>
                                                                <span
                                                                    *ngIf="customer && customer.mobileCode">+{{customer.mobileCode}}-</span>{{customer.mobileNo}}
                                                                <br>
                                                                {{customer.email}}
                                                            </td>
                                                            <td>{{customer.address}} </td>
                                                            <td>{{customer.ownerType}}</td>
                                                            <td class="text-center">
                                                                <ng-container
                                                                    *ngIf="customer.isCompany; else load_else_company">
                                                                    <em class="fas fa-check"></em>
                                                                </ng-container>
                                                                <ng-template #load_else_company>
                                                                    <em class="fas fa-times text-danger"></em>
                                                                </ng-template>
                                                            </td>
                                                            <td class="text-center" *ngIf="customer.searchSource === 'Local' || (_clientName === 'mg' && customer.searchSource === 'CRM')">
                                                                <ng-container
                                                                    *ngIf="customer.isActive; else load_else_isActive">
                                                                    <em class="fas fa-check"></em>
                                                                </ng-container>
                                                                <ng-template #load_else_isActive>
                                                                    <em
                                                                        class="fas fa-times text-danger cursordisable"></em>
                                                                </ng-template>
                                                            </td>
                                                            <td *ngIf="customer.searchSource === 'Data Factory'">
                                                                        
                                                            </td>
                                                            <td>
                                                                <span class="ico-div" [class.invisible]="!AssociateVehicle || customer.customerId != showCustomerVehicle || customer.searchSource !== 'Local'" ></span>
                                                                <a class="btn btn-ico" *ngIf="customer.remark && (customer.searchSource === 'Local' || customer.searchSource === 'CRM')" [ngbTooltip]="tipContent" placement="auto" container="body"> <em class="fa fa-info fa-lg"></em> </a>
                                                                <ng-template #tipContent> 
                                                                    <div class="text-left p-2" style="max-width: 400px;"> 
                                                                        <span> <b> <span translate> lblRemark</span>: </b> </span> <br>
                                                                        <span> {{ customer.remark }} </span> 
                                                                    </div> 
                                                                </ng-template>
                                                                <a class="btn btn-ico" ngbTooltip="Edit" *ngIf="userRoleRightsDetails.canEdit && (customer.searchSource === 'Local' || (customer.searchSource === 'CRM' && customer.customerId > 0))"  (click)="viewCustomer(customer,true)">
                                                                    <em class="fa fa-pencil-alt fa-lg"></em>
                                                                </a>
                                                                <a class="btn btn-ico" ngbTooltip="Add Customer" (click) = "AddCustomerThroughVehicleSearch(customer)" [hidden]="customer.searchSource === 'Local' || customer.searchSource === 'CRM'">
                                                                <em class="fas fa-plus fa-lg"></em>
                                                            </a>
                                                            </td>
                                                        </tr>
                                                    </ng-container>

                                                </ng-container>
                                                <ng-template #load_else>
                                                    <tr>
                                                        <td colspan="6" class="no-record" translate>lblNoRecordsFound
                                                        </td>
                                                    </tr>
                                                </ng-template>
                                            </tbody>
                                        </table>
                                    </div>

                                </ng-template>
                            </ngb-panel>
                            <ngb-panel id="third" *ngIf="!serachByLicensePlate">
                                <ng-template ngbPanelHeader class="custom-header ctm">
                                    <div class="d-flex align-items-center">
                                        <button ngbPanelToggle translate
                                            class="btn d-flex w-100 align-items-center text-left"
                                            aria-label="Center Align">
                                            lblCustomers
                                            <ng-container *ngIf="!a.activeIds.includes('third')"><em
                                                    class="fas fa-angle-down fa-lg ml-auto"></em>
                                            </ng-container>
                                            <ng-container *ngIf="a.activeIds.includes('third')"><em
                                                    class="fas fa-angle-up fa-lg ml-auto"></em>
                                            </ng-container>
                                        </button>
                                        <button *ngIf="addCustomerOrVehicle" type="button"
                                            (click)="OpenAddCustomerModel()" placement="left" ngbTooltip="Add Customer"
                                            tooltipClass="my-tooltip" container="body" class="btn btn-primary btnfix"
                                            aria-label="Center Align">
                                            <i class="fa fa-plus" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </ng-template>
                                <ng-template ngbPanelContent>
                                    <div class="maxh-auto">
                                        <table class="tablest1 border-bottom mt-2">
                                            <thead>
                                                <tr>
                                                    <th scope="col" class="text-center" translate>#</th>
                                                    <th scope="col" translate>lblSource</th>
                                                    <th scope="col" translate>lblCustomerNumber</th>
                                                    <th scope="col" translate>lblCustomerName</th>
                                                    <th scope="col" translate>lblAddress</th>
                                                    <th scope="col" class="text-center" translate>lblIsCompany</th>
                                                    <th scope="col" class="text-center" translate>lblIsActive</th>
                                                    <th scope="col" translate>lblAction</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <ng-container *ngIf="customerDetails?.length>0; else load_else">
                                                    <tr *ngFor="let customer of customerDetails; let i=index"
                                                        [ngClass]="{'clrRed' : !customer.isActive}">
                                                        <td>
                                                            <input type="radio" name="Customerlist" class="radio-custom"
                                                                value="{{customer.customerId}}" *ngIf="customer.searchSource !== 'Data Factory'"
                                                                [checked]="(!hideExtraInformation && customer.customerId==SelectedCustomerId) || (_clientName === 'mg' && customer.Id === SelectedCustomerGuid)"
                                                                (change)="onCustomerChangeGetVehicle(customer.customerId, customer.isActive, customer)" />
                                                        </td>
                                                        <td>{{customer.searchSource}}</td>
                                                        <td>{{customer.customerNo}}</td>
                                                        <td>{{customer.customerName}}
                                                            <br>
                                                            <span *ngIf="customer && customer.mobileCode">+{{customer.mobileCode}}-</span>{{customer.mobileNo}}
                                                            <br>
                                                            {{customer.email}}
                                                        </td>
                                                        <td>{{customer.address}} </td>
                                                        <td class="text-center">
                                                            <ng-container
                                                                *ngIf="customer.isCompany; else load_else_company">
                                                                <em class="fas fa-check"></em>
                                                            </ng-container>
                                                            <ng-template #load_else_company>
                                                                <em class="fas fa-times text-danger"></em>
                                                            </ng-template>
                                                        </td>
                                                        <td class="text-center" *ngIf="customer.searchSource !== 'Data Factory'">
                                                            <ng-container
                                                                *ngIf="customer.isActive; else load_else_isActive">
                                                                <em class="fas fa-check"></em>
                                                            </ng-container>
                                                            <ng-template #load_else_isActive>
                                                                <em class="fas fa-times text-danger cursordisable"></em>
                                                            </ng-template>
                                                        </td>
                                                        <td *ngIf="customer.searchSource === 'Data Factory'">

                                                        </td>
                                                        <td>
                                                            <a class="btn btn-ico" ngbTooltip="Associate Vehicle"
                                                                [hidden]="!AssociateVehicle || customer.customerId != showCustomerVehicle || customer.searchSource !== 'Local'" 
                                                                (click)="AssociateVehicleWithCustomer(customer)">
                                                                <em class="fa fa-car fa-lg"></em>
                                                            </a>
                                                            <a class="btn btn-ico" *ngIf="customer.remark && (customer.searchSource === 'Local' || customer.searchSource === 'CRM')" [ngbTooltip]="tipContent" placement="auto" container="body"> <em class="fa fa-info fa-lg"></em> </a>
                                                            <ng-template #tipContent> 
                                                                <div class="text-left p-2" style="max-width: 400px;"> 
                                                                    <span> <b> <span translate> lblRemark</span>: </b> </span> <br>
                                                                    <span> {{ customer.remark }} </span> 
                                                                </div> 
                                                            </ng-template>
                                                            <span class="ico-div" [class.invisible]="!AssociateVehicle || customer.customerId != showCustomerVehicle || customer.searchSource !== 'Local'" ></span>
                                                            <a class="btn btn-ico" ngbTooltip="Edit" *ngIf="userRoleRightsDetails.canEdit"  (click)="viewCustomer(customer,false)"
                                                                [hidden]="!(customer.searchSource === 'Local' || (_clientName === 'mg' && customer.searchSource === 'CRM' && customer.customerNo))">
                                                                <em class="fa fa-pencil-alt fa-lg"></em>
                                                            </a>
                                                            <a class="btn btn-ico" ngbTooltip="Add Customer" (click) = "AddCustomerThroughVehicleSearch(customer)" [hidden]="customer.searchSource === 'Local' || _clientName === 'mg'">
                                                                <em class="fas fa-plus fa-lg"></em>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                </ng-container>
                                                <ng-template #load_else>
                                                    <tr>
                                                        <td colspan="5" class="no-record" translate>lblNoRecordsFound
                                                        </td>
                                                    </tr>
                                                </ng-template>
                                            </tbody>
                                        </table>
                                    </div>

                                </ng-template>
                            </ngb-panel>
                            <ngb-panel id="forth" *ngIf="isDisplayVehicleForCustomer">
                                <ng-template ngbPanelHeader class="custom-header ctm">
                                    <div class="d-flex align-items-center">
                                        <button ngbPanelToggle translate
                                            class="btn d-flex w-100 align-items-center text-left"
                                            aria-label="Center Align">
                                            lblVehicle
                                            <ng-container *ngIf="!a.activeIds.includes('forth')"><em
                                                    class="fas fa-angle-down fa-lg ml-auto"></em>
                                            </ng-container>
                                            <ng-container *ngIf="a.activeIds.includes('forth')"><em
                                                    class="fas fa-angle-up fa-lg ml-auto"></em>
                                            </ng-container>
                                        </button>
                                        <button *ngIf="addCustomerOrVehicle" type="button"
                                            (click)="OpenAddCustomerModel()" class="btn btn-primary"
                                            aria-label="Center Align">
                                            <i class="fa fa-plus" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </ng-template>
                                <ng-template ngbPanelContent>
                                    <div class="maxh-auto">
                                        <table class="tablest1 border-bottom mt-2">
                                            <thead>
                                                <tr>
                                                    <th scope="col" class="text-center" translate>#</th>    
                                                    <th scope="col" translate>lblSource</th>
                                                    <th scope="col" translate>lblRegNumber</th>
                                                    <th scope="col" translate>lblVinNumber</th>
                                                    <th scope="col" translate>lblRegistrationDate</th>
                                                    <th scope="col" translate>lblNextInspectionDate</th>
                                                    <th scope="col" translate>lblYear</th>
                                                    <th scope="col" translate>lblFuelType</th>
                                                    <th scope="col" translate>lblRelation</th>
                                                    <th style="width:10%" scope="col" class="text-center" *ngIf="userRoleRightsDetailsVehicle.canAdd" translate>
                                                        lblAction
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <ng-container *ngIf="vehicleList?.length>0; else load_else">
                                                    <tr *ngFor="let vehicle of vehicleList; let i=index"
                                                        class="text-center">
                                                        <td>
                                                            <input type="radio" name="list" class="radio-custom"
                                                                value="{{vehicle.vehicleId}}" *ngIf="vehicle.searchSource === 'Local' || (_clientName === 'mg' && vehicle.searchSource === 'CRM')"
                                                                [checked]="(!hideExtraInformation && vehicle.vehicleId==SelectedVehicleId) || (_clientName === 'mg' && vehicle.licensePlateNo === SelectedLicencePlate)"
                                                                (change)="onVehicleChange(i)" />
                                                        </td>
                                                        <td>{{vehicle.searchSource}} </td>
                                                        <td>
                                                            <div class="flmid">
                                                                <div class="licplate LPNo d-flex">
                                                                    <span class="icn-flag"
                                                                        [ngClass]="licensePlateClass"></span>
                                                                    {{vehicle.licensePlateNo}}
                                                                </div>
                                                                <div class="imgWid">
                                                                    <ng-container>
                                                                        <img af-brand-logo
                                                                            [data-code]="vehicle.companyMakeCode"
                                                                            data-type="BRAND"
                                                                            class="{{vehicle.companyMakeCode}}-icon brandicon"
                                                                            alt="not found" />
                                                                    </ng-container>
                                                                </div>
                                                            </div>
                                                            <div class="mt-1">
                                                                <ngb-highlight [result]="vehicle.model"
                                                                    class="flmid semibold fs-12px lh-16px"></ngb-highlight>
                                                            </div>
                                                        </td>
                                                        <td>{{vehicle.chassisNo}} </td>
                                                        <td *ngIf="vehicle.searchSource === 'CRM'">{{vehicle.registrationDate | date:'shortDate'}} </td>
                                                        <td *ngIf="vehicle.searchSource === 'CRM'">{{vehicle.inspectionNextDate | date:'shortDate'}} </td>
                                                        <td *ngIf="vehicle.searchSource !== 'CRM'">{{vehicle.registrationDate}} </td>
                                                        <td *ngIf="vehicle.searchSource !== 'CRM'">{{vehicle.inspectionNextDate}} </td>
                                                        <td>{{vehicle.year}}</td>
                                                        <td>{{vehicle.fuel | titlecase}} </td>
                                                        <td>{{vehicle.ownerType}}  </td>
                                                        <td class="text-center" *ngIf="userRoleRightsDetailsVehicle.canAdd">
                                                            <a class="btn btn-ico" *ngIf="vehicle.remark && (vehicle.searchSource === 'Local' || vehicle.searchSource === 'CRM')" [ngbTooltip]="tipContent" placement="auto" container="body"> <em class="fa fa-info fa-lg"></em> </a>
                                                            <ng-template #tipContent> 
                                                                <div class="text-left p-2" style="max-width: 400px;"> 
                                                                    <span> <b> <span translate> lblRemark</span>: </b> </span> <br>
                                                                    <span> {{ vehicle.remark }} </span> 
                                                                </div> 
                                                            </ng-template>
                                                            <a class="btn btn-ico" ngbTooltip="Add"  (click)="AddNewVehicle(vehicle)"
                                                                [hidden]="!vehicle.isNewVehicle">
                                                                <em class="fas fa-plus fa-lg"></em>
                                                            </a>
                                                            <a class="btn btn-ico" ngbTooltip="Edit" (click)="viewVehicle(vehicle,true)"
                                                            [hidden]="!(!(vehicle.isNewVehicle) && (vehicle.searchSource === 'Local' || (_clientName === 'mg' && vehicle.isExistingVehicle)))">
                                                                <em class="fas fa-pencil-alt fa-lg"></em>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                </ng-container>
                                                <ng-template #load_else>
                                                    <tr>
                                                        <td colspan="6" class="no-record" translate>lblNoRecordsFound
                                                        </td>
                                                    </tr>
                                                </ng-template>
                                            </tbody>
                                        </table>
                                    </div>
                                </ng-template>
                            </ngb-panel>

                             <ngb-panel id="fifth" *ngIf="serachByLicensePlate">
                                <ng-template ngbPanelHeader class="custom-header ctm">
                                    <div class="d-flex align-items-center">
                                        <button ngbPanelToggle translate
                                            class="btn d-flex w-100 align-items-center text-left"
                                            aria-label="Center Align">
                                            lblExistingCustomers
                                            <ng-container *ngIf="!a.activeIds.includes('fifth')"><em
                                                    class="fas fa-angle-down fa-lg ml-auto"></em>
                                            </ng-container>
                                            <ng-container *ngIf="a.activeIds.includes('fifth')"><em
                                                    class="fas fa-angle-up fa-lg ml-auto"></em>
                                            </ng-container>
                                        </button>
                                    </div>
                                </ng-template>
                                <ng-template ngbPanelContent>
                                    <div class="maxh-auto">
                                        <table class="tablest1 border-bottom mt-2">
                                            <thead>
                                                <tr>
                                                    <th scope="col" style="width:8%" class="text-center" translate>lblSearchThrough</th>
                                                    <th scope="col" translate>lblCustomerNumber</th>
                                                    <th scope="col" translate>lblCustomerName</th>
                                                    <th scope="col" translate>lblAddress</th>
                                                    <th scope="col" class="text-center" translate>lblIsActive</th>
                                                    <th scope="col" class="text-center" translate>lblAction</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <ng-container *ngIf="existingDFCustomerDetails?.length>0; else load_else">
                                                    <ng-container>
                                                        <tr *ngFor="let customer of existingDFCustomerDetails; let i=index"
                                                            [ngClass]="{'clrRed' : !customer.isActive}">
                                                            <td class="text-center" style="width:8%">{{customer.searchThrough}} </td>
                                                            <td>{{customer.customerNo}}
                                                            <td>{{customer.customerName}}
                                                                <br>
                                                                <span
                                                                    *ngIf="customer && customer.mobileCode">+{{customer.mobileCode}}-</span>{{customer.mobileNo}}
                                                                <br>
                                                                {{customer.email}}
                                                            </td>
                                                            <td>{{customer.address}} </td>
                                                            <td class="text-center">
                                                                <ng-container
                                                                    *ngIf="customer.isActive; else load_else_isActive">
                                                                    <em class="fas fa-check"></em>
                                                                </ng-container>
                                                                <ng-template #load_else_isActive>
                                                                    <em
                                                                        class="fas fa-times text-danger cursordisable"></em>
                                                                </ng-template>
                                                            </td>
                                                            <td class="text-center">
                                                                <a class="btn btn-ico" ngbTooltip="Associate Customer"
                                                                    (click)="onCustomerSelection(customer)">
                                                                    <em class="fa fa-users fa-lg"></em>
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    </ng-container>
                                                </ng-container>
                                                <ng-template #load_else>
                                                    <tr>
                                                        <td colspan="6" class="no-record" translate>lblNoRecordsFound
                                                        </td>
                                                    </tr>
                                                </ng-template>
                                            </tbody>
                                        </table>
                                    </div>
                                </ng-template>
                            </ngb-panel>
                        </ngb-accordion>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer left-align">
            <div class="d-flex w-100">
                <div class="mr-auto" *ngIf="TCLink">
                    <div class="form-group mb-0 mt-2 form-check" *ngIf="!hidePrivacyPolicy">

                        <input type="checkbox" name="UserPrivacyAccept" [(ngModel)]="UserPrivacyAccept"
                            id="UserPrivacyAccept" class="form-check-input" required
                            (keyup.enter)="OnNext(appointmentList)" />
                        <label class="bold ml-3">

                            <strong class="required-field font-weight-normal"
                                translate>lblreadpolicy</strong>&nbsp;<u><a [href]="TCUrl" class="link" target="_blank"
                                    rel="noopener noreferrer" translate>lblprivacy</a></u>&nbsp;<strong
                                class="required-field font-weight-normal" translate>lblpolicy</strong>

                        </label>
                    </div>
                    <div class="form-group mb-0 mt-2 form-check" *ngIf="!hideMarketingConcent">

                        <input type="checkbox" name="UserConsent" [(ngModel)]="UserConsent" id="UserConsent"
                            class="form-check-input" />

                        <label class="bold ml-3">
                            <strong class="required-field font-weight-normal"
                                translate>lblReceiveDigitalMarket</strong>&nbsp;<u><a [href]="TCUrl" class="link"
                                    target="_blank" rel="noopener noreferrer" translate>lblprivacy</a></u>&nbsp;<strong
                                class="required-field font-weight-normal" translate>lblUserConsent</strong>
                        </label>
                    </div>
                </div>
                <div class="mr-auto" *ngIf="!TCLink">
                    <div class="form-group mb-0 mt-2 form-check" *ngIf="!hidePrivacyPolicy">

                        <input type="checkbox" name="UserPrivacyAccept" [(ngModel)]="UserPrivacyAccept"
                            id="UserPrivacyAccept" class="form-check-input" required />

                        <label class="bold ml-3">
                            <strong class="required-field font-weight-normal"
                                translate>lblIAcceptTheT&C's</strong>&nbsp;<u><a href="javascript:void(0);" class="link"
                                    (click)="openTnCPopup();" translate>lblreadmore</a></u>
                        </label>

                    </div>
                </div>
                <div class="d-flex flex-sm-row flex-column justify-content-end">
                    <button (click)="OnNext(appointmentList)" class="btn btn-primary mr-sm-2 btn-lg mb-1"
                        [disabled]="isDisabled || !(hidePrivacyPolicy || UserPrivacyAccept)" aria-label="Center Align" translate><span
                            translate><em
                                class="fa fa-arrow-circle-right font16 align-top mr-2"></em>Next</span></button>
                    <button (click)="OnClose()" class="btn btn-secondary mb-1 btn-lg" aria-label="Center Align"
                        translate><span translate><em
                                class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</span></button>

                </div>
            </div>
        </div>
    </div>

    <div class="width100" *ngIf="selectDate">

        <div class="modal-body p-0 maxh85vh">
            <div class=" pt-0">


                <div class="mb-3">
                    <div class="">

                        <!--added-->

                        <div class="row" id="morefollowSection">


                            <div class="col-md-4">
                                <div class="af-form-group">
                                    <label translate>lblRegNumber</label>
                                    <div class="lbl-info">
                                        <div class="flmid">
                                            <div class="licplate LPNo d-flex">
                                                <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                                                {{SelectedLicencePlate}}
                                            </div>
                                            <div class="imgWid">
                                                <ng-container>
                                                    <img af-brand-logo [data-code]="SelectedMakeCode" data-type="BRAND"
                                                        class="{{SelectedMakeCode}}-icon brandicon"
                                                        alt="not found" />
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="af-form-group">
                                    <label translate>lblCustomerName</label>
                                    <div class="fs-14px semibold lh-18px d-block"> {{customerName}}
                                    </div>
                                    <div class="d-flex align-items-center fs-12px mt-1 lh-16px">
                                        <em _ngcontent-xdg-c220=""
                                            class="fas fa-phone-flip fs-10px fa-lg mr-2 clr666"></em>
                                        <span class="fs-12px" *ngIf="mobileCode">+{{mobileCode}}-</span>
                                        <div class="fs-12px">{{mobileNumber}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="af-form-group">
                                    <label translate>lblDealersName</label>
                                    <div class="lbl-info">
                                        {{selectedDealerName}}
                                    </div>
                                </div>

                            </div>


                        </div>

                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <div class="cst-input-field big form-group">
                            <label class="mrt20" translate>lblMileage</label>
                            <div class="phone-no relative">
                                <input type="number" value="" class="text-right kminput form-control msh"
                                    [(ngModel)]="mileage" (keyup)="checkMileage()" min="0" maxlength="7" />
                                <span class="country-code km">KM</span>
                            </div>
                            <div translate class="flex-grow cst-validation stepThreeValidation mrt20 text-danger"
                                *ngIf="isMileageError">
                                lblPleaseEnterAppropriateMileage
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label translate>lblService</label><span class="text-danger"> *</span>
                            <div>
                                <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="servicesList"
                                    placeholder="{{ 'lblSelectService'| translate}}" [(ngModel)]="selectedServices"
                                    (ngModelChange)="onChangeService($event)">
                                </ng-multiselect-dropdown>
                            </div>

                        </div>
                    </div>
                    <div class="col-md-3 af-form-group">
                        <label translate>lblPackage</label>
                        <div class="lbl-info" id="appPackage">
                            <ng-select class="" (change)="onChangePackage($event)" name="dealer"
                                [disabled]="isDealerLoggedIn" placeholder="{{ 'lblSelectPackage' | translate }}">
                                <ng-option *ngFor="let pack of package; let i = index" [value]="pack.packageNumber">
                                    {{pack.name}}
                                </ng-option>
                            </ng-select>
                        </div>
                    </div>

                    <div class="col-sm-6">
                    </div>
                </div>

                <div class="form-row mt-4">

                    <div class="col-sm-12">



                        <!--added-->

                        <div class="row">
                            <div class="col-8">
                                <div id="morefollowSection" *ngIf="isRentalService">
                                    <div class="" [ngClass]="!timeSlotSection ? 'enableContent' :'disable' ">
                                        <h3 class="title-h5 bold text-primary">
                                            <span translate>lblWishToRentCar</span>
                                        </h3>

                                        <div class="custom-control custom-checkbox mt-2">

                                            <input type="checkbox" class="custom-control-input" id="needRentalCar"
                                                [(ngModel)]="isNeedRentalCar" (change)="getDealerRentalCarDetails()" />
                                            <label class="custom-control-label" for="needRentalCar"
                                                translate>lblWantCarHire</label>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <div class="col-auto ml-auto">
                                <div class=""
                                    [ngClass]="customerPickupDropOffServiceSelection ? 'enableContent' :'enableContent' ">
                                    <div id="morefollowSection" class="text-right"
                                        *ngIf="selectedDealer && selectedDealer.openingHoursList.length > 0">
                                        <p translate class="text-primary"><strong
                                                translate>lblDealerWorkingDays</strong></p>
                                        <div class="font15">
                                            <ng-container *ngFor="let element of selectedDealer.openingHoursList">
                                                <ul>
                                                    <li>
                                                        <span class="pr10" width="50%">
                                                            <span *ngFor="let day of element.day; let i = index">
                                                                {{day | slice:0:3}}<span>{{i === element.day.length
                                                                    - 1 ? '' : ', '}}</span></span>
                                                        </span>
                                                        <span> <strong> {{element.openingHours}}</strong></span>
                                                    </li>
                                                </ul>
                                            </ng-container>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>



                        <!-- HRENTAL -->
                        <div class="mt-3" *ngIf="!timeSlotSection && isNeedRentalCar" id="rentalCarSection dsw">
                            <div class="cst-input-field">
                                <label translate>lblSelectCarHire</label>
                            </div>
                            <div class="cmn-tbl rental-car-tbl">
                                <table>
                                    <tbody>
                                        <tr class="pos-sticky">
                                            <th scope="col">&nbsp;</th>
                                            <th scope="col" translate>lblBrand</th>
                                            <th scope="col" translate>lblModel</th>
                                            <th scope="col" translate class="text-right">lblPrice</th>
                                        </tr>
                                        <tr *ngFor="let rentalCar of rentalCarAvailabilities; let i = index">
                                            <td>
                                                <label class="cst-radio flexbox">
                                                    <input type="radio" name="rentalcar" class="radio-custom"
                                                        (change)="onChangeRentalCar()"
                                                        [(ngModel)]="selectedRentalCarIndex" [value]="i" />
                                                    <span class="mrt10"></span>
                                                </label>
                                            </td>
                                            <td>{{rentalCar.makeName}}</td>
                                            <td>{{rentalCar.model}}</td>
                                            <td class="text-right">
                                                {{rentalCar.price| number: '1.2-2'}}
                                            </td>
                                        </tr>
                                        <tr *ngIf="rentalCarAvailabilities.length === 0">
                                            <td colspan="4">
                                                <strong translate>lblNoCarAvailableForRent</strong>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>



                    </div>

                    <div class="col-sm-12 mt-4">
                        <div class="form-group mb-0">
                            <label translate>lblSelectDate</label><span class="text-danger"> * </span>
                        </div>
                    </div>
                    <div class="col-sm-4 ">



                        <div class="row">

                            <div class="col-12">
                                <div #appointmentBookingCalendar class="custom-date">
                                    <input type="text" class="form-control" id="bookingCalender" appAfDatepicker
                                        [dateTime]="false" [isInline]="true" [isOnlyTime]="false"
                                        [startDate]="todayDate" [value]="selectedDate" [endDate]="endDate"
                                        [defaultDate]="selectedDate ? selectedDate : dealerNextAvailDate"
                                        (OnSelect)="changeDate($event)" (OnChangeMonthYear)="onChangeMonthYear($event)"
                                        (OnGenerate)="onChangeInCalender()" [disableNextMonthDates]="true" />
                                </div>
                            </div>
                            <div class="col-auto">
                                <div class="mt-2">
                                    <div class="d-flex align-items-center">
                                        <label class="duration nowrap pr-2"><span
                                                translate>lblAppointmentTime</span><strong class="required">
                                                * </strong></label>
                                        <div class="">
                                            <div class="d-flex">
                                                <input type="number" class="duration-hr form-control hideArrow"
                                                    placeholder="HH" [(ngModel)]="AppointmentHour" maxlength="2"
                                                    (keyup)="MoveToAppointmentDurationMinute($event)" min="0" max="23"
                                                    onkeydown="if(event.key==='.'){event.preventDefault();}"
                                                    oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');">
                                                <span class="py-2 px-2"> : </span>
                                                <input type="number" class="duration-min form-control hideArrow"
                                                    (keyup)="CheckAppointmentMinute($event)"
                                                    [(ngModel)]="AppointmentMinutes" min="0" max="59"
                                                    #AppointmentminuteInput placeholder="MM"
                                                    onkeydown="if(event.key==='.'){event.preventDefault();}"
                                                    oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="border p-1 mt-3" *ngIf="isRentalService">
                                    <div class="calendar-legends">
                                        <strong class="color-bg " style="background-color:#b8fdc0"></strong>
                                        <span class="flex-center calendar-legend-text"
                                            translate>lblAvailableDatesForDealerWithRentalCars</span>
                                    </div>
                                    <div class="calendar-legends">
                                        <strong class="color-bg " style="background-color:#fff "></strong> <span
                                            class="flex-center calendar-legend-text" translate>
                                            lblAvailableDatesForDealerWithoutRentalCars</span>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>

                    <div class="col-sm-8">
                        <div class="border pad15">
                            <div class="">


                                <div class="form-row align-items-center mb-2">
                                    <div class="col-auto">
                                        <div class="custom-control custom-checkbox ">
                                            <input type="checkbox" id="customerPickupDropupService"
                                                [(ngModel)]="customerPickupDropOffServiceSelection"
                                                (change)="onChangeCustomerPickupDropupServiceCheckbox()"
                                                class="custom-control-input" />
                                            <label class="custom-control-label" for="customerPickupDropupService"
                                                translate>lblIwantCarPickupAndDropUpService</label>
                                        </div>
                                    </div>
                                    <div class="col-auto ml-auto">
                                        <div class="mt-2"
                                            [ngClass]="customerPickupDropOffServiceSelection? 'enableContent' :'disable' ">
                                            <div class="d-flex">
                                                <label class="duration nowrap col-form-label pr-2"><span
                                                        translate>lblPickUpTime</span><strong class="required">
                                                        * </strong></label>
                                                <div class="">
                                                    <div class="d-flex">


                                                        <input type="number" class="duration-hr form-control hideArrow"
                                                            [(ngModel)]="pickUpHours" maxlength="2"
                                                            (keyup)="MoveToDurationMinute($event)" placeholder="HH"
                                                            min="0" max="23"
                                                            onkeydown="if(event.key==='.'){event.preventDefault();}"
                                                            oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');">
                                                        <span class="py-2 px-2"> : </span>
                                                        <input type="number" class="duration-min form-control hideArrow"
                                                            placeholder="MM" (keyup)="CheckMinute($event)"
                                                            [(ngModel)]="pickUpMinutes" min="0" max="59"
                                                            #pickUpminuteInput
                                                            onkeydown="if(event.key==='.'){event.preventDefault();}"
                                                            oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-row align-items-center mb-2"
                                    *ngIf="selectedDealer && selectedDealer.customerWaitingLimit>0">
                                    <div class="col-12"
                                        [ngClass]="!customerPickupDropOffServiceSelection? 'enableContent' :'disable' ">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" id="customerWaiting" [(ngModel)]="timeSlotSection"
                                                (change)="onChangeCustomerWaitingCheckbox()"
                                                class="custom-control-input" />
                                            <label class="custom-control-label" for="customerWaiting"
                                                translate>lblWantToWaitForReapired</label>
                                        </div>
                                        <em class="" style="padding-left: 30px;" translate>
                                            lblAffectAvailableDays
                                            <!-- (This may affect available days) -->
                                        </em>
                                    </div>
                                </div>



                                <div class="mt-4"
                                    [ngClass]="!timeSlotSection && !customerPickupDropOffServiceSelection ? 'enableContent' :'disable' ">


                                    <div class="list-group">
                                        <div class="mt-2">
                                            <h3 class="title-h5 bold">
                                                <!-- Will you like to avail Online Check-In facility? -->
                                                <span translate>lblWillYouLikeToAvailOnlineCheck-In facility?</span>

                                            </h3>
                                            <div class="mt10 row">
                                                <div class="col col-md-6">
                                                    <label class="cst-radio flexbox">
                                                        <input type="radio" name="onlinecheckin"
                                                            [(ngModel)]="availCheckInFacility" value="true" />
                                                        <span class="mrt10"></span>
                                                        <p translate>lblYes</p>
                                                    </label>
                                                </div>
                                                <div class="col col-md-6">
                                                    <label class="cst-radio flexbox">
                                                        <input type="radio" name="onlinecheckin"
                                                            [(ngModel)]="availCheckInFacility" value="false" />
                                                        <span class="mrt10"></span>
                                                        <p translate>lblNot</p>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-3">
                                            <h3 class="title-h5  bold">
                                                <strong><span translate>lblWhenYouDeliverTheCar</span></strong>
                                            </h3>
                                            <div class="mt10 row">
                                                <div class="col col-md-6">
                                                    <label class="cst-radio flexbox">
                                                        <input type="radio" name="delivercar"
                                                            [(ngModel)]="deliverCarWithinBusinessHours"
                                                            [value]="true" />
                                                        <span class="mrt10"></span>
                                                        <p translate><span translate>lblWithinBusinessHour</span>
                                                            <span> {{businesshours}}</span>
                                                        </p>

                                                    </label>
                                                </div>
                                                <div class="col col-md-6">
                                                    <label class="cst-radio flexbox">
                                                        <input type="radio" name="delivercar"
                                                            [(ngModel)]="deliverCarWithinBusinessHours"
                                                            [value]="false" />
                                                        <span class="mrt10"></span>
                                                        <p translate>lblOutsideOpeningHours</p>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-3">
                                            <h3 class="title-h5  bold">
                                                <span translate>lblWhenYouPickTheCar</span>
                                            </h3>
                                            <div class="row mt10">
                                                <div class="col col-md-6">
                                                    <label class="cst-radio flexbox">
                                                        <input type="radio" name="pickupcar"
                                                            [(ngModel)]="pickupCarWithinBusinessHours" [value]="true" />
                                                        <span class="mrt10"></span>
                                                        <p translate>
                                                            <span translate>lblWithinBusinessHour</span>
                                                            <span> {{businesshours}}</span>
                                                        </p>
                                                    </label>
                                                </div>
                                                <div class="col col-md-6">
                                                    <label class="cst-radio flexbox">
                                                        <input type="radio" name="pickupcar"
                                                            [(ngModel)]="pickupCarWithinBusinessHours"
                                                            [value]="false" />
                                                        <span class="mrt10"></span>
                                                        <p>Outside opening hours - use the keypad</p>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>




                                </div>

                            </div>
                        </div>
                        <div class="flex-grow cst-validation stepTwoValidation mrt20 wartxt"
                            *ngIf="rentalCarValidationMessage">
                            <span translate>lblSelectedRentalCarIsNotAvailableOn </span>{{ selectedDate |
                            date:'shortDate'}}.
                            <span translate>lblPleaseChooseADifferentDate.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <button (click)="Back()" class="btn btn-secondary mb-1" aria-label="Center Align" translate><span
                    translate>Back</span></button>
            <button (click)="EmailNotifyUser()" class="btn btn-primary mr-sm-2 mb-1" aria-label="Center Align"
                [disabled]="!(!!addAppointment && !!selectedDealer && !!selectedDate && !rentalCarValidationMessage && !isMileageError && !(customerPickupDropOffServiceSelection && !pickUpHours) )"
                translate><span translate>lblAddAppointment</span></button>
            <button (click)="OnClose()" class="btn btn-secondary mb-1" aria-label="Center Align" translate><span
                    translate>lblCancel</span></button>
        </div>




    </div>





    <ng-template #appointmentList let-modal>
        <div class="modal-header">
            <h4 class="modal-title" id="modal-basic-title" translate>
                PAY ATTENTION! <span class="small-txt">ALREADY PLANNED APPOINTMENT FOR THIS CAR</span>
            </h4>
            <button type="button" id="modelButton" class="close" aria-label="Center Align"
                (click)="modal.dismiss('Cross click');CloseAttention()">
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div class="width100">
            <div class="modal-body">
                <div class="row">
                    <div class="col-12">
                        <button type="button" type="reset" id="closeBtn" aria-label="Center Align"
                            class="ml-3 add-button btn btn-primary float-right mb-3"
                            (click)="modal.dismiss('Cross click');ConfirmAddAppointment()"
                            translate>lblAddAppointment</button>
                    </div>
                </div>

                <div class="row">
                    <div class="c12">
                        <div class="card mb-3">
                            <div class="card-header d-flex px-3" translate>
                                lblAppointment
                            </div>

                            <div class="table-responsive max-h260">
                                <table class="tablest1">
                                    <thead>
                                        <tr>
                                            <th style="width:5%" scope="col" translate class="">lblType</th>
                                            <th style="width:8%" scope="col" translate>lblWoNo</th>
                                            <th style="width:20%" scope="col" translate>lblRegNumber
                                            </th>
                                            <th style="width:110px" scope="col" translate>lblSource</th>
                                            <th style="width:20%" class="ST" scope="col" translate>
                                                lblCustomer
                                            </th>
                                            <th style="width:20%" scope="col" translate>lblDealersName</th>
                                            <th style="width:5%" scope="col" translate class="text-center" *ngIf="isShowDMSStatus">lblStatus
                                            </th>
                                            <th style="width:7%" scope="col" translate>lblBookedDate</th>
                                            <th style="width:7%" scope="col" translate>lblCreatedDate</th>
                                            <th scope="col" style="width:150px" translate class="text-center">lblAction
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngIf="activeAppointmentList?.length>0; else load_else">
                                            <tr *ngFor="let appointment of activeAppointmentList; let i=index">
                                                <td>
                                                    <ngb-highlight [result]="appointment.appointmentType">
                                                    </ngb-highlight>
                                                </td>
                                                <td>
                                                    <ngb-highlight [result]="appointment.workOrderNo">
                                                    </ngb-highlight>
                                                </td>
                                                <td>
                                                    <div class="flmid">
                                                        <div class="licplate LPNo d-flex">
                                                            <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                                                            {{appointment.licensePlate}}
                                                        </div>
                                                        <div class="imgWid">
                                                            <ng-container>
                                                                <img af-brand-logo [data-code]="appointment.brand" data-type="BRAND"
                                                                    class="{{appointment.brand.name}}-icon common"
                                                                    [title]="appointment.brandCode" class="brandicon"
                                                                    alt="img" />
                                                            </ng-container>
                                                        </div>
                                                    </div>
                                                    <div class="mt-1">
                                                        <ngb-highlight class="flmid semibold fs-12px lh-16px"
                                                            [result]="appointment.modelName"></ngb-highlight>
                                                    </div>
                                                </td>
                                                <td>
                                                    <ngb-highlight
                                                        class="flmid sourceBox rounded-0 justify-content-center"
                                                        [result]="appointment.sourceCreation">
                                                    </ngb-highlight>
                                                </td>
                                                <td>
                                                    <ngb-highlight class="fs-16px semibold lh-18px d-block"
                                                        [result]="appointment.customerName">
                                                    </ngb-highlight>
                                                    <div class="d-flex align-items-center fs-12px mt-1 lh-16px">
                                                        <em _ngcontent-xdg-c220=""
                                                            class="fas fa-phone-flip fs-10px fa-lg mr-2 clr666"></em>
                                                        <span class="fs-12px"
                                                            *ngIf="appointment && appointment.mobileCode">+{{appointment.mobileCode}}-</span>
                                                        <ngb-highlight class="fs-12px" [result]="appointment.mobileNo">
                                                        </ngb-highlight>
                                                    </div>

                                                </td>
                                                <td>
                                                    <ngb-highlight [result]="appointment.dealerName">
                                                    </ngb-highlight>
                                                </td>
                                                <td class="position-relative" *ngIf="isShowDMSStatus">
                                                    <div class="mx-auto text-center">
                                                        <div class="color-box"
                                                            [ngbTooltip]="appointment.appointmentStatus"
                                                            [style.background-color]="appointment.appointmentStatusColor">
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    {{ appointment.bookedDate | date:'short'}}
                                                </td>
                                                <td>
                                                    {{ appointment.createdDateTime | date:'short'}}
                                                </td>
                                                <td>
                                                    <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}"
                                                        (click)="editAppointment(appointment)">
                                                        <em class="fas fa-pencil-alt fa-lg"></em>
                                                    </a>
                                                </td>

                                        </ng-container>
                                        <ng-template #load_else>
                                            <tr>
                                                <td colspan="10" class="no-record" translate>lblNoRecordsFound</td>
                                            </tr>
                                        </ng-template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>

    </ng-template>
    <ng-template #customerRelationContent let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>lblCustomers</h4>
        <button type="button" #closeModal id="modelButton" class="close" aria-label="Center Align"
            (click)="modal.dismiss(false)">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="card pad15">
            <div class="row">
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <input type="checkbox" name="customerRadio" class="mr-2" (change)="changeRelationType($event,'Owner')">
                                    <label translate class="mr-3">
                                        lblOwner
                                    </label>
                                    <input type="checkbox" name="customerRadio" class="ml-2" (change)="changeRelationType($event,'Payer')">
                                    <label translate class="ml-2 mr-3">
                                        lblPayer
                                    </label>
                                    <input type="checkbox" name="customerRadio" class="ml-2" (change)="changeRelationType($event,'User')">
                                    <label translate class="ml-2 mr-3">
                                        lblUser
                                    </label>
                                    <input type="checkbox" name="customerRadio" class="ml-2" (change)="changeRelationType($event,'Driver')">
                                    <label translate class="ml-2 mr-3">
                                        lblDriver
                                    </label>
                                </td>
                            </tr>
                        </tbody>
                    </table>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="d-flex flex-sm-row flex-column justify-content-end">
            <button type="submit" class="btn btn-primary mr-sm-2" translate  aria-label="Center Align" 
            [disabled]="vehicleService.customerRelationType == null"
            (click)="AssociateDFCustomerWithVehicle();modal.dismiss('Cross click')">lblSave</button>
            <button (click)="modal.dismiss(false)" class="btn btn-secondary" aria-label="Center Align"
                translate>lblCancel</button>
        </div>
    </div>
</ng-template>